import PaintPins from "../../board/PaintPins";

export default function redrawCanvas() {
  PaintPins(this.ctx, this.canvas, this.state.board, this.state.coeffs);
  let i = 0;
  while (this.balls[i]) {
    this.balls[i].draw();
    i++;
  }
}
